// src/modules/marketplace/store/realizationSlice.ts

import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { RootState, StateFromRoot, registerReducer } from "@core/store"
import { GridPaginationModel } from "@mui/x-data-grid-pro"
import { GRID_PAGE_SIZE_OPTIONS } from "@/core/constants"
import { Realization } from "../interfaces"

const STATE_KEY = "realization"

const defaultPagination: GridPaginationModel = {
  page: 0,
  pageSize: GRID_PAGE_SIZE_OPTIONS[0], // 25
}

interface IState {
  realizationPagination: GridPaginationModel
  batchesPagination: GridPaginationModel
  realizationFilters: Realization.RealizationQueryParams
  batchesFilters: Realization.BatchesQueryParams
}

const initialState: IState = {
  realizationPagination: defaultPagination,
  batchesPagination: defaultPagination,
  realizationFilters: {},
  batchesFilters: {},
}

export const realizationSlice = createSlice({
  name: STATE_KEY,
  initialState,
  reducers: {
    setRealizationPagination: (
      state,
      { payload }: PayloadAction<GridPaginationModel>,
    ) => {
      state.realizationPagination = payload
    },
    setBatchesPagination: (
      state,
      { payload }: PayloadAction<GridPaginationModel>,
    ) => {
      state.batchesPagination = payload
    },
    setRealizationFilters: (
      state,
      { payload }: PayloadAction<Realization.RealizationQueryParams>,
    ) => {
      state.realizationFilters = payload
      // Reset to page 0 on filter change
      state.realizationPagination = {
        ...state.realizationPagination,
        page: 0,
      }
    },
    setBatchesFilters: (
      state,
      { payload }: PayloadAction<Realization.BatchesQueryParams>,
    ) => {
      state.batchesFilters = payload
      state.batchesPagination = {
        ...state.batchesPagination,
        page: 0,
      }
    },
  },
})

registerReducer(realizationSlice.name, realizationSlice.reducer)

export const {
  setRealizationPagination,
  setBatchesPagination,
  setRealizationFilters,
  setBatchesFilters,
} = realizationSlice.actions

export const getRealizationState = (state: RootState<StateFromRoot<IState>>) =>
  state.realization
